import { createFileRoute, redirect } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { SpSidebar } from '../components/Sidebar';
import { SubmitForm } from '../components/SubmitForm';
import { NoticeLarge } from '@moonjellydigital/react-components';
import { getAuthStore } from '../main';
import { Submit } from '../components/Submit';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/submit-artwork')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();

    const isAuthenticated = getAuthStore().getIsAuthenticated();
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    const userRole = getAuthStore().getUser()?.role;
    if (userRole !== 'artist') {
      throw redirect({ to: '/' });
    }
  },
  component: SubmitArtwork,
});

function SubmitArtwork() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <SpSidebar />
        <Pane classes={'sp-main'} tag="main">
          <h1>Submit Your Artwork</h1>
          <Submit />
        </Pane>
      </div>
    </>
  );
}
